import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {useDatabaseItemApiStore} from '@toolify/client/src/stores/api/DatabaseItemApiStore/useDatabaseItemApiStore'
import {useMessages} from '@toolify/client/src/modules/notifications/composables/useMessages'
import {i18n} from '@toolify/client/src/setup/i18n'
import {ApiException} from '@toolify/server/src/middleware/ApiResponseMiddleware/errors/ApiException'
import {KnownError} from '@toolify/server/src/middleware/ApiResponseMiddleware/types/KnownError'

export function beforeDatabaseItemByKeyRouterHookFactory(pinia: Pinia) {
  return async function beforeDatabaseItemByKeyRouterHook(to: RouteLocationNormalized) {
    const databaseId = to.params.databaseId as string
    const databaseItemKey = to.params.databaseItemKey as string
    const databaseRoute = {
      name: RouteName.Database,
      params: {
        workspaceName: to.params.workspaceName,
        databaseId,
      },
    }
    if(!databaseId || !databaseItemKey) {
      return databaseRoute
    }
    const databaseItemApiStore = useDatabaseItemApiStore(pinia)
    const messages = useMessages()

    try {
      const {databaseItemId} = await databaseItemApiStore.getItemByKey(databaseId, databaseItemKey)

      return {
        name: RouteName.DatabaseItem,
        params: {
          workspaceName: to.params.workspaceName,
          databaseId,
          databaseItemId,
        },
      }
    } catch (error) {
      if(!(error instanceof ApiException)) {
        throw error
      }
      if(error.name === KnownError.NoPermissions) {
        return databaseRoute
      }
      if(error.name === KnownError.NotFound) {
        messages.error(i18n.global.t('database.itemByKeyNotFound', {key: databaseItemKey}))
        return databaseRoute
      }
      throw error
    }
  }
}
